// @flow
import { merge } from 'lodash';
import type { CustomerActionType } from './actions';

export type CustomerStateType = {|
  data: Object,
  failure: boolean,
  hasEditedIdentificationInfo?: boolean,
|};

const initialState: CustomerStateType = {
  data: {},
  failure: false,
};

export default function customer(
  state: CustomerStateType = initialState,
  action: CustomerActionType
): CustomerStateType {
  switch (action.type) {
    case 'SET_CUSTOMER':
      return {
        data: action.payload.customer,
        failure: false,
      };
    case 'FETCH_CUSTOMER_FAILURE':
      return {
        ...state,
        failure: true,
      };
    case 'SIGNUP_STORE_PASSPORT_INFO':
      return {
        ...state,
        data: merge(state.data, action.payload.customer),
      };
    case 'SIGNUP_SET_PERSONAL_INFO':
      const { identification, ...customer } = action.payload;
      return {
        ...state,
        data: customer,
      };
    case 'SIGNUP_SET_BILLING_ADDRESS':
      return {
        ...state,
        data: {
          ...state.data,
          billingAddress: action.payload.billingAddress,
        },
      };
    case 'SIGNUP_CLEAR_PERSONAL_INFO':
      return {
        ...state,
        data: state.data || {},
      };
    case 'HAS_MANUALLY_EDITED_ID':
      return {
        ...state,
        hasEditedIdentificationInfo: true,
      };
    case 'SET_CUSTOMER_OPTION_COMMERCIAL':
      return {
        ...state,
        data: {
          ...state.data,
          login: {
            ...state.data.login,
            customerPreference: {
              ...state.data.login.customerPreference,
              characteristics: action.payload.customerOptionCommercial,
            },
          },
        },
      };
    default:
      return state;
  }
}
